import { render, staticRenderFns } from "./TestQuestionManualForm.vue?vue&type=template&id=fb514b80&scoped=true&"
import script from "./TestQuestionManualForm.vue?vue&type=script&lang=ts&"
export * from "./TestQuestionManualForm.vue?vue&type=script&lang=ts&"
import style0 from "./TestQuestionManualForm.vue?vue&type=style&index=0&id=fb514b80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb514b80",
  null
  
)

export default component.exports